import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IconsModule } from "@va/core-library/icons";
import { SharedModule } from "../shared/shared.module";

import { HistoryModalComponent } from "./history-modal/history-modal.component";

// ant modules
import { NzTableModule } from "ng-zorro-antd/table";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";

@NgModule({
  declarations: [HistoryModalComponent],
  imports: [
    CommonModule,
    NzTableModule,
    NzModalModule,
    NzButtonModule,
    IconsModule,
    SharedModule,
    FormsModule,
    NzToolTipModule,
  ],
  exports: [HistoryModalComponent],
})
export class ReportCenterSharedModule {}
